import { render, staticRenderFns } from "./PaginaChartBiglietteria.vue?vue&type=template&id=8eae2d20"
import script from "./PaginaChartBiglietteria.vue?vue&type=script&lang=js"
export * from "./PaginaChartBiglietteria.vue?vue&type=script&lang=js"
import style0 from "./PaginaChartBiglietteria.vue?vue&type=style&index=0&id=8eae2d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports